import { ReactNode } from 'react'

import FansiClassStepOne from '@/public/assets/instruction-card/fansi-class/step_1.svg'
import FansiClassStepTwo from '@/public/assets/instruction-card/fansi-class/step_2.svg'
import FansiClassStepThree from '@/public/assets/instruction-card/fansi-class/step_3.svg'
import FansiVideoStepOne from '@/public/assets/instruction-card/fansi-video/step_1.svg'
import FansiVideoStepTwo from '@/public/assets/instruction-card/fansi-video/step_2.svg'
import FansiVideoStepThree from '@/public/assets/instruction-card/fansi-video/step_3.svg'
import FansiKind from '@/ts/enums/global/FansiKind'

const { FansiClass, FansiVideo } = FansiKind

const INSTRUCTIONS: Record<Key, Instruction[]> = {
  [FansiClass]: [
    {
      image: <FansiClassStepOne />,
      text: 'instructions.fansi_class.1',
    },
    {
      image: <FansiClassStepTwo />,
      text: 'instructions.fansi_class.2',
    },
    {
      image: <FansiClassStepThree />,
      text: 'instructions.fansi_class.3',
    },
  ],
  [FansiVideo]: [
    {
      image: <FansiVideoStepOne />,
      text: 'instructions.fansi_video.1',
    },
    {
      image: <FansiVideoStepTwo />,
      text: 'instructions.fansi_video.2',
    },
    {
      image: <FansiVideoStepThree />,
      text: 'instructions.fansi_video.3',
    },
  ],
}

type Key = Exclude<
  FansiKind,
  'digital' | 'fansi_collection' | 'fansi_experience' | 'fansi_projects'
>

interface Instruction {
  image: ReactNode
  text: string
}

export default INSTRUCTIONS
